<template>
  <invitation-mobile-index v-if="screenSize === 'mobile'" />
  <invitations-table v-else />
</template>

<script type="text/javascript">
import InvitationMobileIndex from '@/views/common/InvitationMobileIndex.vue';
import InvitationsTable from '@/views/common/tables/InvitationsTable.vue';

export default {
  name: 'Users Invitations Index',
  components: {
    InvitationMobileIndex,
    InvitationsTable,
  },
  props: {
    screenSize: String,
  },
};
</script>
